// removed by extract-text-webpack-plugin
module.exports = {"input":"input___28NnK","switch":"switch___2IUI3","switchBtn":"switchBtn___3AfO3","option":"option___3yhCJ","entry":"entry___3exYb","label":"label___i1R7B","delete":"delete___HFTDM","add":"add___1TBfo","handle":"handle___1KmoZ","bars":"bars___uKlvU"};


//////////////////
// WEBPACK FOOTER
// /app/js/components/EditVariable/BlankEditor/styles.scss
// module id = 443
// module chunks = 0